import { useQuery } from '@tanstack/react-query';
import { apiRequest } from '@/lib/api-client';

export interface ReferenceCompanyOption {
  id: string;
  name: string;
  company_type: string;
  // Every service type the company actively holds; was single-valued before
  // the transport party registry.
  service_type: string[];
}

export function useReferenceCompanies() {
  return useQuery({
    queryKey: ['reference', 'companies', 'counterparty'],
    queryFn: () =>
      apiRequest<ReferenceCompanyOption[]>('/reference/companies', {
        query: { type: 'counterparty', limit: 200 },
      }),
  });
}
